export function getQueryValues(keys, defaultVal = null) {
  const { search: oriSearch, hash } = window.location;
  const locSearch = oriSearch.replace('&amp;', '&');
  const hashQuery = hash.split('?')[1] || '';
  const search = `${locSearch}&${hashQuery}`;
  const data = {};
  if (Array.isArray(keys)) {
    if (window.URLSearchParams) {
      const params = new URLSearchParams(search);
      keys.forEach((key) => {
        const val = params.get(key) || defaultVal;
        data[key] = val;
      });
    } else {
      keys.forEach((key) => {
        const match = new RegExp(`[?&]${key}=([^&]*)`).exec(search);
        const result = match && decodeURIComponent(match[1].replace(/\+/g, ' '));
        data[key] = result || defaultVal;
      });
    }
  }
  return data;
}

export function guid() {
  return 'xxxxxxx-xxxxxx-xxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getCookie(name) {
  try {
    const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
    const arr = document.cookie.match(reg);
    if (arr) {
      return decodeURIComponent(arr[2]);
    }
  } catch (error) {
    console.log(error);
  }
  return null;
}

/* 获取M站登录 token */
export function getMphoneToken() {
  const hdcn = getCookie('HDCN');
  if (typeof hdcn === 'string' && hdcn) {
    return hdcn.substring(0, 20);
  }
  return null;
}

/**
 * 把一个对象的key-value转化成querystring的形式
 * @param 要转换的对象
 * @returns {string} 转换后的字符串
 */
export function toQueryString(obj) {
  if (obj) {
    const data = Object.keys(obj).map((key) => {
      const value = obj[key];
      let originText = '';
      if (value != null) {
        if (value instanceof Object) {
          originText = JSON.stringify(value);
        } else {
          originText = value;
        }
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(originText)}`;
    });
    return data.join('&');
  }
  return '';
}

export const handleBridgeData = (str) => {
  if (str && typeof str === 'string') {
    return JSON.parse(str);
  }
  return str;
};

export const delay = (time) => new Promise((resolve) => {
  setTimeout(() => resolve(), time);
});

export function wakeupApp(jumpURL, scheme, replace) {
  if (scheme) {
    let iframe = document.querySelector('#open_app_iframe');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.setAttribute('id', 'open_app_iframe');
      iframe.setAttribute('width', '1px');
      iframe.setAttribute('height', '1px');
      iframe.style.cssText = 'position:fixed;top:-200px;height:0px;width:0px;overflow:hidden;';
      document.body.appendChild(iframe);
    }
    setTimeout(() => {
      iframe.setAttribute('src', scheme);
    });
  }
  if (jumpURL) {
    const openTask = setTimeout(() => {
      if (replace) {
        window.location.replace(jumpURL);
        return;
      }
      window.location.href = jumpURL;
    }, 800);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'visible') {
        clearTimeout(openTask);
      }
    });
  }
}
